import React, { Component } from 'react';

import './ContactForm.css'
import { showNotification as showNotificationAction } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
const request = require('superagent');
var Config = require('../config');

var email,category,description;

class PassForm extends Component {

  constructor(props) {
  super(props);

  console.log("props",props.record);
  var userID= props.record.userID;
  if(userID){
    email=props.record.userID.email;
    category=props.record.category;
    description=props.record.description;
  }

    this.state = {value: ''};

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

}

handleChange(event) {
   this.setState({value: event.target.value});
 }

  handleSubmit(event) {
    //alert('A name was submitted: ' + this.state.value);
    event.preventDefault();

    var answer=this.state.value;
    var auth_token = localStorage.getItem('auth_token');

    request
       .post(Config.serverUrl+'/api/send_email')
       .send({answer: answer,email:email,category:category,description:description,token:auth_token})
       .set('Accept', 'application/json')
       .then(function(res) {
         alert('The email has been send.');
         console.log("success");
       })
       .catch((e) => {
           alert('The email has been send.');
            console.error(e);
        });

  }

  render() {
    return (
      <form className="contact-form" onSubmit={this.handleSubmit} >

        <div className="form-field">
          <label htmlFor="message">
            <div className="label-content">Answer:</div>
            <textarea value={this.state.value} onChange={this.handleChange} className="stretch" name="message" rows="5" required />
          </label>
        </div>

        <button type="submit" className="button_sub">Send</button>
      </form>
    );
  }
}

PassForm.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
})(PassForm);



// WEBPACK FOOTER //
// ./src/custom/answerButton.js